.root {
  height: auto;
  padding-left: var(--mantine-spacing-sm);
  padding-right: var(--mantine-spacing-sm);
  background-color: var(--mantine-color-orange-1);
  color: var(--mantine-color-orange-7);
  font-weight: 500;
}

.root:hover {
  background-color: var(--mantine-color-orange-2);
}

.label {
  white-space: normal;
  overflow: visible;
  color: var(--mantine-color-brand-7);
  padding-top: 10px;
  padding-bottom: 10px;
}

.section {
  color: var(--mantine-color-brand-7);
}
